__turbopack_context__.v({
  "segmentCount": "M0-Uqa_segmentCount",
  "segmented": "M0-Uqa_segmented",
  "segmentedBtn": "M0-Uqa_segmentedBtn",
});
